import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import './GeneralErrorPage.scss';
import { t } from 'i18next';

function GeneralErrorPage(): JSX.Element {
    return (
        <div className='general-error-wrapper'>
            <div className='general-error-content row'>
                <div className='col-sm-3 col-sx-12 icon-wrapper'>
                    <FontAwesomeIcon
                        icon={faExclamationCircle}
                        color='red'
                        size='3x'
                    />
                </div>
                <div className='col-sm-9 col-xs-12 text-wrapper'>
                    <p>{t('page_not_found')}</p>
                </div>
            </div>
        </div>
    );
}

export default GeneralErrorPage;
